import useFetch from '../../../hooks/useFetch';
import { WarehouseOrderExpeditionFilters } from '../../models/WareHouseOrderExpedition';
import { WarehouseExpeditionDataForm } from '../../models/WareHouseQuoteExpedition';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseOrderExpeditionService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetWarehouseOrderExpedition, setFetchingGetWarehouseOrderExpedition] = useState(false);
  const [fetchingUpdateWarehouseOrderExpedition, setFetchingUpdateWarehouseOrderExpedition] = useState(false);
  const [fetchingGetWarehouseOrderExpeditions, setFetchingGetWarehouseOrderExpeditions] = useState(false);
  const [fetchingStoreWarehouseOrderExpedition, setFetchingStoreWarehouseOrderExpedition] = useState(false);
  const [fetchingShowWarehouseOrderExpedition, setFetchingShowWarehouseOrderExpedition] = useState(false);
  const [fetchingDeleteWarehouseOrderExpedition, setFetchingDeleteWarehouseOrderExpedition] = useState(false);
  const [fetchingEditWarehouseOrderExpedition, setFetchingEditWarehouseOrderExpedition] = useState(false);
  const [fetchingCreateWarehouseOrderExpedition, setFetchingCreateWarehouseOrderExpedition] = useState(false);
    const [fetchingshowExpeditionWarehouseOrderExpedition, setFetchingShowExpeditionWarehouseOrderExpedition] =
        useState(false);
  const getWarehouseOrderExpedition = (OrderId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDER_EXPEDITION.replace(':warehouse_order_id', OrderId.toString()),
      setFetching: setFetchingGetWarehouseOrderExpedition
    });
  };

  const getAllWarehouseOrderExpeditionsByOrder = (
        OrderId: number,
        expeditionFilters: WarehouseOrderExpeditionFilters, 
        events: ServiceEvents = {}
    ) => {
    
    const queryString = Object.entries(expeditionFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
    const url = `${EndPoints.WAREHOUSE_ORDERS.GET_ALL_WAREHOUSE_ORDER_EXPEDITIONS}?${queryString}`;
    
    doGet({
      ...events,
        url: url.replace(
            ':warehouse_order_id',
            OrderId.toString()
        ),
      setFetching: setFetchingGetWarehouseOrderExpeditions
    });
  };

  const storeWarehouseOrderExpedition = (data: WarehouseExpeditionDataForm, events: ServiceEvents = {}) => {
    doPost({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.STORE_WAREHOUSE_ORDER_EXPEDITION,
      body: data,
      setFetching: setFetchingStoreWarehouseOrderExpedition
    });
  };

  const showWarehouseOrderExpedition = (id: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.SHOW_WAREHOUSE_ORDER_EXPEDITION.replace(':warehouse_order_id', id.toString()),
      setFetching: setFetchingShowWarehouseOrderExpedition
    });
  };

  const deleteWarehouseOrderExpedition = (id: number, events: ServiceEvents = {}) => {
    doDelete({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.DELETE_WAREHOUSE_ORDER_EXPEDITION.replace(':id', id.toString()),
      setFetching: setFetchingDeleteWarehouseOrderExpedition
    });
  };

  const updateWarehouseOrderExpedition = (OrderId: number, data: WarehouseExpeditionDataForm, events: ServiceEvents = {}) => {
    doPut({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.UPDATE_WAREHOUSE_ORDER_EXPEDITION.replace(':warehouse_order_id', OrderId.toString()),
      body: data,
      setFetching: setFetchingUpdateWarehouseOrderExpedition
    });
  };

  const createWarehouseOrderExpedition = (OrderId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.CREATE_WAREHOUSE_ORDER_EXPEDITION.replace(':warehouse_order_id', OrderId.toString()),
      setFetching: setFetchingCreateWarehouseOrderExpedition
    });
  };

  const editWarehouseOrderExpedition = (OrderId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_ORDERS.EDIT_WAREHOUSE_ORDER_EXPEDITION.replace(':warehouse_order_id', OrderId.toString()),
      setFetching: setFetchingEditWarehouseOrderExpedition
    });
  };

  const showExpeditionWarehouseOrderExpedition = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.SHOW_EXPEDITION_WAREHOUSE_ORDER_EXPEDITION.replace(
                ':expedition_id',
                id.toString()
            ),
            setFetching: setFetchingShowExpeditionWarehouseOrderExpedition
        });
    };

  return {
    getWarehouseOrderExpedition,
    getAllWarehouseOrderExpeditionsByOrder,
    storeWarehouseOrderExpedition,
    showWarehouseOrderExpedition,
    updateWarehouseOrderExpedition,
    createWarehouseOrderExpedition,
    editWarehouseOrderExpedition,
    deleteWarehouseOrderExpedition,
    showExpeditionWarehouseOrderExpedition,

    fetchingGetWarehouseOrderExpedition,
    fetchingUpdateWarehouseOrderExpedition,
    fetchingGetWarehouseOrderExpeditions,
    fetchingStoreWarehouseOrderExpedition,
    fetchingShowWarehouseOrderExpedition,
    fetchingDeleteWarehouseOrderExpedition,
    fetchingCreateWarehouseOrderExpedition,
    fetchingEditWarehouseOrderExpedition,
    fetchingshowExpeditionWarehouseOrderExpedition
  };
};

export default useWarehouseOrderExpeditionService;
